module Eseebase {

    export class HelperService {
        public static SortArray(array: any[], sortBy: string) {
            if (array == null || array.length == 0) {
                return array;
            }
            return array.sort((a: any, b: any) => {
                var i = 0;
                var left = '';
                var right = '';
                if (sortBy == null) {
                    if (a == null && b != null) {
                        return -1;
                    }
                    if (a != null && b == null) {
                        return 1;
                    }
                    if (a == null && b == null) {
                        return 0;
                    }
                    left = a.toString().toLowerCase();
                    right = b.toString().toLowerCase();
                }
                else {
                    if (a != null && a[sortBy] != null && (b == null || b[sortBy] == null)) {
                        return -1;
                    }
                    if ((a == null || a[sortBy] == null) && b != null && b[sortBy] == null) {
                        return -1;
                    }
                    if ((a == null || a[sortBy] == null) && (b == null || b[sortBy] == null)) {
                        return 0;
                    }
                    left = a[sortBy].toString().toLowerCase();
                    right = b[sortBy].toString().toLowerCase();
                }
                var leftRegexp = /[\d]+/g;
                var rightRegexp = /[\d]+/g;
                var leftDigits = leftRegexp.exec(left);
                var rightDigits = rightRegexp.exec(right);
                var leftIdx = 0;
                var rightIdx = 0;
                var leftString = '';
                var rightString = '';
                while (leftDigits != null && rightDigits != null) {
                    var leftString = left.substring(leftIdx, leftDigits.index);
                    var rightString = right.substring(rightIdx, rightDigits.index);
                    if (leftString < rightString) {
                        return -1;
                    }
                    if (leftString > rightString) {
                        return 1;
                    }
                    var leftInt = parseInt(leftDigits[0]);
                    var rightInt = parseInt(rightDigits[0]);
                    if (leftInt < rightInt) {
                        return -1;                         
                    }
                    if (leftInt > rightInt) {
                        return 1;
                    }
                    leftIdx = leftDigits.index + leftDigits[0].length;
                    rightIdx = rightDigits.index + rightDigits[0].length;
                    leftDigits = leftRegexp.exec(left);
                    rightDigits = rightRegexp.exec(right);
                }

                leftString = left.substring(leftIdx);
                rightString = right.substring(rightIdx);
                return leftString < rightString ? -1 : leftString > rightString ? 1 : 0;
            });
        }
    }
}